import { Target } from "@labs/shared/types/Target.ts";
import { EmissionsBySource } from "@labs/shared/types/EmissionsBySource.ts";
import { AnalyzedPlan } from "@labs/shared/types/AnalyzedPlan.ts";

export const getActiveStepIndex = (
  target: Target,
  baselineEmissions: EmissionsBySource,
  analyzedPlan: AnalyzedPlan,
  planEmailed: boolean,
): number => {
  const hasPlan = analyzedPlan.planComponents.length > 0;
  const hasBaseline = Object.values(baselineEmissions).some(
    (value) => value > 0,
  );
  const hasTarget = target.goal > 0;

  if (planEmailed) return 4;
  if (hasPlan && hasBaseline && hasTarget) return 3;
  if (hasBaseline && hasTarget) return 2;
  if (hasTarget) return 1;
  return 0;
};
